import { render, staticRenderFns } from "./ItemDeprecatedDialog.vue?vue&type=template&id=3e90b0ee&"
import script from "./ItemDeprecatedDialog.vue?vue&type=script&lang=js&"
export * from "./ItemDeprecatedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports